import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { VwapPromiseService, PairVwap } from "shared/cubiq-services";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { BfxBaseBlotter } from "../bfx-base-blotter/bfx-base-blotter";
import { BfxBlotterOrders } from "../bfx-blotter-orders/bfx-blotter-orders";
import { BfxTradeBlotterComponent } from "../bfx-blotter-trade/bfx-trade-blotter.component";

export const VWAP_PAIR_SORT: any = (a, b) => {
  return a.pairName.toLowerCase() < b.pairName.toLowerCase()
    ? -1
    : a.pairName.toLowerCase() > b.pairName.toLowerCase()
    ? 1
    : 0;
};
import { LoggerService } from "@bfx/logger";
import { Vwap } from "shared/cubiq-services/mediator/IVwapService";
const logger = LoggerService.for(__dirname);

@Injectable()
export abstract class BfxVwapService {
  private isVwapShown: boolean = false;

  public showVwapSubject: Subject<BfxVwapTooltipEvent> = new Subject<BfxVwapTooltipEvent>();

  constructor(protected vwapService: VwapPromiseService) {}

  // TODO BfxTradeBlotterComponent will be subclassing base
  public attachVwap(blotter: BfxBaseBlotter) {}

  public showVwap(
    menuBoundingClientRect: any,
    orderIds: Array<string>,
    blotterId: string,
    ndfMode: boolean = false,
  ): void {
    if (!this.isVwapShown) {
      this.getPairsVwap(orderIds, ndfMode).then((pairs) => {
        pairs.pairVWaps.sort(VWAP_PAIR_SORT);
        let amountWithOz = false;
        for (let i = 0; i < pairs.pairVWaps.length; ++i) {
          if (pairs[i].useOzs) {
            amountWithOz = true;
            break;
          }
        }
        this.showVwapSubject.next(
          new BfxVwapTooltipEvent(
            BfxVwapTooltipEventType.VWAP_SHOW,
            menuBoundingClientRect,
            pairs.pairVWaps,
            amountWithOz,
            blotterId,
          ),
        );
        this.isVwapShown = true;
      });
    }
  }

  public hideVwap(): void {
    if (this.isVwapShown) {
      this.showVwapSubject.next(new BfxVwapTooltipEvent(BfxVwapTooltipEventType.VWAP_HIDE));
      this.isVwapShown = false;
    }
  }

  public abstract getPairsVwap(selectedIds: Array<string>, ndfMode?: boolean): Promise<Vwap>;
}

export enum BfxVwapTooltipEventType {
  VWAP_SHOW,
  VWAP_HIDE,
}

export class BfxVwapTooltipEvent {
  constructor(
    public eventType: BfxVwapTooltipEventType,
    public menuBoundingClientRect?: any,
    public pairVwaps?: Array<PairVwap>,
    public amountWithOz?: boolean,
    public blotterId?: string,
  ) {}
}
